import { alpha } from '@mui/material/styles';
import { Box, MenuItem, Stack, IconButton, Popover, Typography, Badge } from '@mui/material';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import React from 'react';
import { getNotifications } from 'src/services/notification.service';
import { formatDate } from 'src/methods/common.methods';

// ----------------------------------------------------------------------

export default class NotificationsPopover extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      open: null,
      notifications: [],
      loading: false,
    };
  }

  handleOpen = (event) => {
    this.fetchNotifications();
    this.setState({ open: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ open: null });
  };

  async fetchNotifications() {
    this.setState({ loading: true });
    let notificationsResponse = await getNotifications();
    this.setState({ notifications: notificationsResponse.notifications || [], loading: false });
  }

  render() {
    const { open } = this.state;

    return (
      <>
        <IconButton
          onClick={this.handleOpen}
          sx={{
            padding: 0,
            width: 44,
            height: 44,
            ...(open && {
              bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.action.focusOpacity),
            }),
          }}
        >
          <NotificationsNoneIcon />
        </IconButton>

        <Popover
          open={Boolean(open)}
          anchorEl={open}
          onClose={this.handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <Stack spacing={1} sx={{ padding: 1, minWidth: 300 }}>

            {this.state.loading && (
              <Typography variant="body2" color="text.secondary" noWrap sx={{ p: 1 }} textAlign={'center'}>
                Loading...
              </Typography>
            )}

            {(!this.state.loading && this.state.notifications.length === 0) && (
              <Typography variant="body2" color="text.secondary" noWrap sx={{ p: 1 }} textAlign={'center'}>
                No new notifications
              </Typography>
            )}

            {this.state.notifications.map((notification, index) => (
              <MenuItem
                key={index}
                onClick={this.handleClose}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  backgroundColor: notification.read ? 'transparent' : 'rgba(0, 123, 255, 0.1)',
                }}
              >
                {notification.read ? (
                  <CheckCircleIcon color="primary" fontSize="small" />
                ) : (
                  <FiberManualRecordIcon color="error" fontSize="small" />
                )}
                <Box sx={{ ml: 1 }}>
                  <Typography variant="subtitle2" noWrap>
                    {notification.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" noWrap>
                    {notification.message}
                  </Typography>
                  <Typography variant="caption" color="text.disabled" noWrap>
                    {formatDate(notification.created_at)}
                  </Typography>
                </Box>
              </MenuItem>
            ))}
          </Stack>
        </Popover>
      </>
  );
  }
}
